import { bodyRequest, queryRequest } from './axios'

// 省市县

export const queryDistrict = ( datas ) => {
  return queryRequest( datas, 'region/queryDistrict' )
}

// 获取省 
export const queryProvince = ( datas ) => {
  return queryRequest( datas, 'region/queryProvince' )
}

// 获取字典值
export const queryDictionary = ( datas ) => {
  return queryRequest( datas, 'sys/queryDictionary' )
}


// 新增报名人员
export const addEnterForm = ( datas ) => {
  return bodyRequest( datas, 'enter/v1/addEnterForm' )
}


















// WEBPACK FOOTER //
// ./src/assets/js/caseRequest.js